import { render, staticRenderFns } from "./RechtaktuellPage.vue?vue&type=template&id=d8464fc6&"
import script from "./RechtaktuellPage.vue?vue&type=script&lang=js&"
export * from "./RechtaktuellPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports